<mat-error *ngIf="isSecurityDefaultsEnabled ">
    You can't Add or Enable any conditional access policy while your Security Defaults Policy is enabled. Please disable
    it and try again.
</mat-error>

<mat-error *ngIf="noIncludeUsers">
    At least one rule in 'users' condition is required. Try to include any roles/users/groups or even set include users
    to 'none' to start with.
</mat-error>

<mat-error *ngIf="isBlockingEveryOne">
    Don't lock yourself out! We recommend applying a policy to a small set of users first to verify it behaves as
    expected. We also recommend excluding at least one administrator from this policy. This ensures that you still have
    access and can update a policy if a change is required. Please review the affected users.
</mat-error>

<mat-error *ngIf="isNoSessionOrGrantControl">
    Session or grant controls is required
</mat-error>

<mat-error *ngIf="conditionWithSeiCustomizeContinuousAccessDisabled">
    You cannot disable <span class="bold"> Continuous Access Evaluation (CAE) </span> if your conditional access policy
    includes any conditions like <span> (User risk, Sign-in risk, Insider risk, Include platforms, Exclude platforms,
        Client apps or Authentication flows) </span> or specifies included locations.

</mat-error>

<mat-error *ngIf="isPersistentBrowserSessionWithNoResource">
   Persistent browser session only works correctly when All cloud apps is selected. Please change your cloud apps selection.

</mat-error>

<form *ngIf="policy$ | async as policy" [formGroup]="form">
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>

        <tr>
            <td>
                Policy Name
            </td>

            <td>
                <ng-container *ngIf="policy?.displayName && policy?.id">
                    <div class="d-flex items-center gap-[6px]">
                        <div>{{ policy.displayName }}</div>
                        <mat-icon class="text-[20px]" [matTooltip]="'Id: ' + policy.id">info</mat-icon>
                    </div>
                </ng-container>

                <ng-container *ngIf="!policy?.displayName">
                    Baseline has not been linked to a policy
                </ng-container>


                <button
                    [matTooltip]="allConditionalAccessPolicies?.length == 0 ? 'No conditional access policies found' : ''"
                    [disabled]="allConditionalAccessPolicies?.length == 0" class="!block mt-2" color="primary"
                    mat-button (click)="openRemapPolicyDialog()">

                    <span *ngIf="!baseline?.key">Associate with an existing policy (optional)</span>
                    <span *ngIf="baseline?.key">Modify the linked policy (optional)</span>
                </button>
            </td>





            <td>
                <div class="field boolean">
                    <mat-form-field appearance="fill">
                        <mat-label>Display Name</mat-label>

                        <input matInput [disabled]="readOnly" formControlName="displayName">

                        <mat-error>Display name is required</mat-error>
                    </mat-form-field>
                </div>
            </td>

            <td>
                <ng-container *ngIf="policy?.id">

                    <sway-baseline-status *ngIf="form.get('state').value !=='delete'"
                        [hasError]="errorsString?.includes('displayName!')"></sway-baseline-status>

                    <mat-icon *ngIf="form.get('state').value =='delete'">remove</mat-icon>
                </ng-container>

                <mat-icon *ngIf="!policy?.id">
                    <mat-icon class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>
                </mat-icon>
            </td>

        </tr>

        <tr>
            <td>
                State
            </td>

            <td>
                <div class="validator">
                    <div *ngIf="!policy?.id; else elseBlock">
                        Policy Not Found
                    </div>

                    <ng-template #elseBlock>
                        <div class="capitalize">
                            <ng-container *ngIf="policy?.state === 'enabledForReportingButNotEnforced'">
                                Report-only
                            </ng-container>

                            <ng-container *ngIf="policy?.state !== 'enabledForReportingButNotEnforced'">

                                {{policy?.state }}
                            </ng-container>


                        </div>
                    </ng-template>
                </div>
            </td>

            <td>
                <div class="field boolean">
                    <mat-form-field appearance="fill">
                        <mat-label>State</mat-label>
                        <mat-select [disabled]="readOnly" formControlName="state">
                            <mat-option [value]="'enabled'">Enable</mat-option>
                            <mat-option [value]="'disabled'">Disable</mat-option>
                            <mat-option [value]="'enabledForReportingButNotEnforced'">Report-only</mat-option>
                            <!-- <mat-option [value]="'delete'">No Policy (Delete)</mat-option> -->
                        </mat-select>
                    </mat-form-field>
                </div>
            </td>

            <td>
                <ng-container *ngIf="policy?.id">

                    <sway-baseline-status *ngIf="form.get('state').value =='delete'"
                        [hasError]="!!policy?.id"></sway-baseline-status>

                    <sway-baseline-status *ngIf="form.get('state').value !=='delete'"
                        [hasError]="errorsString?.includes('state!')"></sway-baseline-status>
                </ng-container>

                <mat-icon *ngIf="!policy?.id">
                    <mat-icon class="warn-icon" matTooltip="Baseline is not associated with any policy">warning</mat-icon>
                </mat-icon>
            </td>
        </tr>
    </table>

    <ng-content></ng-content>

    <ng-container *ngIf="policy?.id || form.get('state').value !=='delete'">
        <sway-baseline-cap-config [schema$]="schema$" [baselineTemplateItem]="baselineTemplateItem"
            [tenant_id]="tenant_id" [readOnly]="readOnly" [form]="form" [policy$]="policy$">
        </sway-baseline-cap-config>
    </ng-container>
</form>
